export const isSelfRegUnsetProfile = (customer) =>
  Number(customer?.added_by_id) === 0 &&
  !customer?.gst &&
  !customer?.urp &&
  (!customer?.address || customer?.address === '-') &&
  (!customer?.city || customer?.city === '-');

export const getDisplayAddress = (customer) => {
  const address = customer?.address;
  if (!address || address === '-') {
    return '';
  }
  return address;
};

export const getDisplayCity = (customer) => {
  const city = customer?.city;
  if (!city || city === '-') {
    return '';
  }
  return city;
};

export const getDisplayBranch = (customer) => {
  if (isSelfRegUnsetProfile(customer) || !customer?.branch_id) {
    return '';
  }
  return customer?.branch_name || '';
};

export const getDisplayCreatedBy = (customer) => {
  if (Number(customer?.added_by_id) === 0 || !customer?.added_by?.trim()) {
    return 'N/A';
  }
  return customer.added_by;
};
